define('collection/ServiceCollection',['require','lib/collection/FilterableCollection','model/ServiceModel'],function (require) {
	
	var FilterableCollection = require('lib/collection/FilterableCollection');
	var ServiceModel = require('model/ServiceModel');
	
	/**
	 * Services list collection
	 * 
	 * @class ServiceCollection
	 */
	return FilterableCollection.extend({
		
		url: '/service/',
		model: ServiceModel,

		_classesFirst: false,

        getClassOrderCorrection: function (mode) {
            this._classesFirst = (mode === 'class');

			var model = this.max(function (model) {
				return parseInt(model.get('position'));
			});
			// model is for IE hack
			if (model && !_.isUndefined(model)) {
			    if (model.get) {
                    return model.get('position') * (this._classesFirst ? -1 : 1) * 1000;
                }
			}
			return 0;
		},

		setClassesFirst: function (flag) {
			this._classesFirst = flag;
		},

        hasClassesAndServices: function () {
            var hasClass = false;
            var hasService = false;
            this.each(function (model) {
                if (model.get('class_id')) {
                    hasClass = true;
                } else {
                    hasService = true;
                }
            });
            return hasClass && hasService;
        },

        getFirstServiceIndex: function () {
			return this.findIndex(function (model) {
				return !model.get('class_id');
			});
		},

        getFirstClassIndex: function () {
            return this.findIndex(function (model) {
                return !!model.get('class_id');
            });
		}
		
	});
	
});
